import { configConstants } from "../constants";

const initialState = {};

export function config(state = initialState, action) {
  switch (action.type) {
    //GET CONFIG FOR CURRENT SCHEMA
    case configConstants.CONFIG_REQUEST:
      return {
        loading: true
      };
    case configConstants.CONFIG_SUCCESS:
      return {
        loading: false,
        ...action.config
      };
    case configConstants.CONFIG_FAILURE:
      return {
        loading: false,
        error: action.error
      };

    case configConstants.CONFIG_MAINTANANCE_FAILURE:
      return {
        loading: false,
        ...action.maintananceErrorData
      };

    default:
      return state;
  }
}
